<div class="storeExplorer text-grey" style="height: 100%;">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">
      Select SyncStore File
    </h4>
    <i
      style="z-index: 1"
      class="bi bi-x-lg text-danger"
      color="warn"
      (click)="onCancel()"
      title="Close"
    ></i>
  </div>
  <div class="modal-body flex-grow-1">
    <div class="syncBreadcrumb">
      <b>Files In : </b>
      <div class="d-flex flex-grow-1" *ngIf="!isBreadCrumbEditable">
        <ol #syncStoreBreadCrumb class="breadcrumb">
          <li
            class="breadcrumb-item"
            *ngFor="let crumb of storeBreadCrumb | storageBreadcrumb:4"
            title="{{ crumb.path }}"
          >
            <span
              (click)="onNavigation(crumb)"
              style="cursor: pointer"
              class="{{ crumb.className }}"
              >{{ crumb.ui_name }}</span
            >
          </li>
        </ol>
        <p class="flex-grow-1 m-0" (click)="isBreadCrumbEditable = !isBreadCrumbEditable"></p>
        <i title="Copy current path" class="bi me-2" style="color: var(--s-primary-color)" [ngClass]="{ 'bi-clipboard': !copiedTooltip.isOpen(), 'bi-clipboard-check': copiedTooltip.isOpen() }" [cdkCopyToClipboard]="breadCrumbPath" placement="bottom" triggers="hover" ngbTooltip="Copied" autoClose="outside" triggers="click:blur" #copiedTooltip="ngbTooltip"></i>
      </div>
      <div *ngIf="isBreadCrumbEditable" class="d-flex flex-grow-1">
        <form action="" (keyup.enter)="handleSearchedPath()" class="d-flex w-75">
          <input [(ngModel)]="breadCrumbPath" name="breadCrumbPath" class="flex-grow-1 ms-3 mb-0" style="outline: none;" autofocus/>
          <i class="bi bi-x-square ms-2 mt-1" style="color: var(--s-primary-color)" (click)="isBreadCrumbEditable=false;setDefaultBreadCrumbPath()"></i>
          <i class="bi bi-arrow-right-square ms-2 mt-1" style="color: var(--s-primary-color)" (click)="handleSearchedPath()"></i>
        </form>
      </div>
    </div>
    <div *ngIf="toShowError == false" class="storeData">
      <div class="searchBar d-flex align-items-center" *ngIf="storeItems">
        <input *ngIf="!toChooseSingle" type="checkbox" title="Select All" style="width: 2%" class="me-2" (change)="onSelectAllCheckBox($event)" [checked]="selectAll" id="">
        <input class="storageSearch" type="search" placeholder="Find" title="Find files/folders in current path."  [(ngModel)]="storageSearch"> 
        <span class="storageSearchCancel bi bi-x-lg text-danger" *ngIf="storageSearch" (click)="resetStorageSearch()"></span>
      </div>
      <ul class="d-flex mb-1">
        <li></li>
        <li></li>
        <li style="margin-left: 2.7rem; width: 77%; font-weight: bold;">Name</li>
        <li style="font-weight: bold">Size</li>
      </ul>
      <ul class="filesData">
        <li
          *ngFor="let item of (storeItems | filterSearch:storageSearch) as folder; let i = index"
          class="{{ item.type }} parentData d-flex text-align-center"
          [ngClass]="{ active: multiSelectIndex.includes(item) }"
          (click)="activateClass(item)"
          (dblclick)="onNavigation($event, item, i)"
        >
          <input
            type="checkbox"
            title="Select File"
            class="selectCheckbox"
            [checked]="multiSelectIndex.includes(item)"
          />
          <span class="bi" [ngClass]="item.type == 'file' ? 'bi-file-earmark' : 'bi-folder-fill'"></span>
          <p class="w-75">
            <a
              href="#"
              onclick="return false;"
              id="{{ i }}"
              class="fileNames"
              style="cursor: default; text-decoration: none!important;"
              attr.data-directory-path="{{ item.path }}"
              title="{{ item?.name }}"
              >{{ item?.name }}</a
            >
          </p>
          <span>{{ item.size | fileSize }}</span>
        </li>
      </ul>
    </div>
    <div *ngIf="toShowError == true" class="errorMsg">
      <p>{{ errorMsg }}</p>
    </div>
    <div class="w-100 text-center mt-1 d-none" *ngIf="toChooseSingle && storeItems">
      <input id="toZipCheck" [(ngModel)]="toZipCheck" type="checkbox"><label for="toZipCheck" class="ms-1">This is .zip file and unzip while data copy</label>
    </div>
    <ngx-spinner
      bdColor="rgba(0,0,0,0)"
      size="default"
      name="storeSpinner"
      color="var(--s-primary-color)"
      type="ball-spin"
      [fullScreen]="false"
      ><p style="margin-top: 2rem;"> Please wait ... </p>
    </ngx-spinner>
  </div>
  <div class="modal-footer" style="padding: 0.5rem 1rem; display: flex; align-items: center;">
    <div *ngIf="toChooseSingle && toShowError == false" class="note-msg" style="position: absolute; left: 1rem;">
      <strong>Note:</strong> Only single file selection is allowed.
    </div>
    <div class="ms-auto d-flex gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="onRefresh()">
        Refresh
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        Close
      </button>
      <button type="button" class="btn btn-primary" (click)="onSubmit()" cdkFocusInitial>
        Add
      </button>
    </div>
  </div>
